import { useVehiclesListQuery } from 'src/common/external/bambi-api/bambiApi';

export function useSchedulableVehicle(vehicleId?: string) {
  const { data, isLoading, isFetching } = useVehiclesListQuery({
    canBeScheduled: true,
  });

  const vehicle = (data?.results ?? []).find(
    (vehicle) => vehicle.id === vehicleId
  );

  return { vehicle, isLoading, isFetching };
}
